'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

export const ViewportControl = () => {
  const pathname = usePathname()

  useEffect(() => {
    // Cập nhật viewport mỗi khi route thay đổi
    const setViewportMeta = () => {
      // Tìm viewport meta hiện tại
      let viewportMeta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement

      // Nếu không có, tạo mới
      if (!viewportMeta) {
        viewportMeta = document.createElement('meta')
        viewportMeta.setAttribute('name', 'viewport')
        document.head.appendChild(viewportMeta)
      }

      // Set content cho phép user-scalable theo chuẩn WCAG/Lighthouse Accessibility
      viewportMeta.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0, user-scalable=yes, viewport-fit=cover'
      )
    }

    setViewportMeta()
  }, [pathname]) // Re-run khi route thay đổi

  return null
}

